export const PREFERENCE_LABELS: Record<ShipmentNotificationPreference, string> =
  {
    ALL: "All Shipments",
    LANE_FILTERED: "Matching Lanes Only",
  };
